<template>
  <div class="navBar navBar--fixed">
    <b-navbar
      toggleable="xl"
      :variant="isDarkTheme ? 'dark' : 'light'"
      :type="isDarkTheme ? 'dark' : 'light'"
      class="top-navbar-main shadow-sm rounded-0 px-2 px-xl-3"
    >
      <b-navbar-brand href="/" >
        <img class="nav-logo" src="../../../src/assets/images/logo.png" alt="logo" />
      </b-navbar-brand>
      <b-navbar-toggle style="font-size:15px" target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav class="navbar-collapse-main flex-grow-1">
        <b-navbar-nav class="nav-items mr-auto flex-wrap">
          <b-nav-item @click="goToRoute('landingPage')">{{ langDec.nav_home }}</b-nav-item>
          <b-nav-item>
            <b-nav-item-dropdown style="margin-top: -8px;" :text="langDec.nav_about_takhaty" right>
              <b-dropdown-item @click="goToRoute('aboutUs')">{{ langDec.nav_about_company }}</b-dropdown-item>
              <b-dropdown-item @click="goToRoute('abouCEO')">{{ langDec.nav_founder }}</b-dropdown-item>
              <b-dropdown-item @click="goToRoute('experts')">{{ langDec.nav_experts }}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>
          <b-nav-item @click="goToRoute('consultations')">{{ langDec.nav_consultations }}</b-nav-item>
          <b-nav-item @click="goToRoute('articles')">{{ langDec.nav_blog }}</b-nav-item>
          <b-nav-item @click="goToRoute('clubs')">{{ langDec.nav_clubs }}</b-nav-item>
          <b-nav-item @click="goToRoute('checkYourSelf')">{{ langDec.nav_check_yourself }}</b-nav-item>

          <b-nav-item >
            <b-nav-item-dropdown style="margin-top: -7px;" :text="langDec.nav_study_practice" right>
              <b-dropdown-item @click="goToRoute('creative')">{{ langDec.nav_creative }}</b-dropdown-item>
              <b-dropdown-item @click="goToRoute('books')">{{ langDec.nav_publications }}</b-dropdown-item>
              <b-dropdown-item @click="goToRoute('trainings')">{{ langDec.nav_cme }}</b-dropdown-item>
            </b-nav-item-dropdown>
          </b-nav-item>
          <!-- <b-nav-item @click="goToRoute('contactus')">تواصل معنا</b-nav-item> -->
        </b-navbar-nav>

        <b-navbar-nav class="navbar-actions align-items-center flex-row flex-shrink-0">
          <div class="nav-actions-cluster">
            <div class="nav-dock" aria-hidden="false">
              <div
                class="lang-switcher lang-switcher--in-dock"
                role="group"
                :aria-label="langDec.nav_lang_aria"
              >
                <button
                  type="button"
                  class="lang-switcher__btn"
                  :class="{ 'lang-switcher__btn--active': currentLang === 'ar' }"
                  :aria-pressed="currentLang === 'ar' ? 'true' : 'false'"
                  @click="setLang('ar')"
                >
                  AR
                </button>
                <button
                  type="button"
                  class="lang-switcher__btn"
                  :class="{ 'lang-switcher__btn--active': currentLang === 'en' }"
                  :aria-pressed="currentLang === 'en' ? 'true' : 'false'"
                  @click="setLang('en')"
                >
                  EN
                </button>
              </div>

              <span class="nav-dock__divider" aria-hidden="true" />

              <button
                type="button"
                class="theme-switch-compact theme-switch-compact--in-dock"
                :class="{ 'theme-switch-compact--dark-mode': isDarkTheme }"
                role="switch"
                :aria-checked="isDarkTheme ? 'true' : 'false'"
                :aria-label="isDarkTheme ? langDec.theme_switch_aria_dark : langDec.theme_switch_aria_light"
                :title="isDarkTheme ? langDec.theme_switch_title_dark : langDec.theme_switch_title_light"
                @click="toggleTheme"
              >
                <b-icon icon="sun-fill" class="theme-switch-compact__icon theme-switch-compact__icon--sun" />
                <span class="theme-switch-compact__track" aria-hidden="true">
                  <span
                    class="theme-switch-compact__thumb"
                    :class="{ 'theme-switch-compact__thumb--on': isDarkTheme }"
                  />
                </span>
                <b-icon icon="moon-fill" class="theme-switch-compact__icon theme-switch-compact__icon--moon" />
              </button>
            </div>

            <b-button
              size="sm"
              class="btn-contact-nav btn-contact-nav--wow"
              variant="primary"
              @click="goToRoute('contactus')"
            >
              {{ langDec.nav_contact }}
            </b-button>
          </div>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["isDarkTheme", "getlang", "getLangData"]),
    langDec() {
      return this.getLangData || {};
    },
    currentLang() {
      return this.getlang || "ar";
    },
  },
  methods: {
    toggleTheme() {
      this.$store.commit("SET_THEME", this.isDarkTheme ? "light" : "dark");
    },
    goToRoute(name) {
      this.$router.push({
        name,
      }).catch(()=>{});
    },

    setLang(lang) {
      if (lang !== "ar" && lang !== "en") return;
      if (this.getlang === lang) return;
      this.$store.commit("SET_LANG", lang);
      this.$store.commit("SET_INTERNATIONALIZATION", lang);
    },
  },
};
</script>

<style scoped lang="scss">
.navBar--fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1030;
  padding: 0;
  margin: 0;
}

.top-navbar-main {
  transition: background-color 0.2s ease, box-shadow 0.2s ease;
  border-radius: 0 !important;
  width: 100%;
}

/* يملأ المسافة بين الشعار والروابط؛ mr-auto على الروابط يدفع مجموعة الإجراءات لطرف الشاشة في LTR */
.top-navbar-main ::v-deep .navbar-collapse-main.navbar-collapse {
  flex-grow: 1;
}

@media (min-width: 1200px) {
  .top-navbar-main ::v-deep .navbar-collapse-main.navbar-collapse {
    display: flex !important;
    flex-basis: auto;
    flex-wrap: wrap;
    align-items: center;
  }
}

.nav-logo {
  display: block;
  width: auto;
  max-width: min(180px, 42vw);
  max-height: 54px;
  height: auto;
  object-fit: contain;
}

.navbar-actions {
  align-items: center;
  gap: 0;
  flex-wrap: wrap;
  margin-top: 0.35rem;
}

@media (min-width: 1200px) {
  .navbar-actions {
    margin-top: 0;
  }
}

/* مجموعة واحدة: كبسولة زجاجية + زر تواصل متماشي */
.nav-actions-cluster {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  flex-wrap: wrap;
}

.nav-dock {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 5px 8px 5px 10px;
  border-radius: 999px;
  isolation: isolate;
  transition: box-shadow 0.35s ease, transform 0.25s ease, border-color 0.25s ease;
}

.top-navbar-main.navbar-light .nav-dock {
  background: linear-gradient(
    155deg,
    rgba(255, 255, 255, 0.97) 0%,
    rgba(241, 249, 245, 0.92) 48%,
    rgba(230, 242, 234, 0.95) 100%
  );
  border: 1px solid rgba(0, 102, 51, 0.14);
  box-shadow:
    0 4px 18px rgba(0, 102, 51, 0.1),
    0 1px 0 rgba(255, 255, 255, 0.95) inset,
    0 0 0 1px rgba(255, 255, 255, 0.5) inset;
}

.top-navbar-main.navbar-dark .nav-dock {
  background: linear-gradient(
    165deg,
    rgba(255, 255, 255, 0.11) 0%,
    rgba(255, 255, 255, 0.04) 42%,
    rgba(0, 0, 0, 0.12) 100%
  );
  border: 1px solid rgba(255, 255, 255, 0.16);
  box-shadow:
    0 10px 40px rgba(0, 0, 0, 0.45),
    0 0 28px -8px rgba(0, 168, 98, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.14),
    inset 0 -1px 0 rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
}

.nav-dock:hover {
  transform: translateY(-1px);
}

.top-navbar-main.navbar-light .nav-dock:hover {
  box-shadow:
    0 8px 28px rgba(0, 102, 51, 0.14),
    0 1px 0 rgba(255, 255, 255, 1) inset;
}

.top-navbar-main.navbar-dark .nav-dock:hover {
  border-color: rgba(255, 255, 255, 0.22);
  box-shadow:
    0 12px 44px rgba(0, 0, 0, 0.5),
    0 0 36px -6px rgba(72, 224, 160, 0.45),
    inset 0 1px 0 rgba(255, 255, 255, 0.18);
}

.nav-dock__divider {
  width: 1px;
  height: 22px;
  flex-shrink: 0;
  border-radius: 1px;
  opacity: 0.85;
}

.top-navbar-main.navbar-light .nav-dock__divider {
  background: linear-gradient(
    180deg,
    transparent,
    rgba(0, 102, 51, 0.28) 30%,
    rgba(0, 102, 51, 0.28) 70%,
    transparent
  );
}

.top-navbar-main.navbar-dark .nav-dock__divider {
  background: linear-gradient(
    180deg,
    transparent,
    rgba(255, 255, 255, 0.35) 35%,
    rgba(255, 255, 255, 0.35) 65%,
    transparent
  );
}

/* لغة داخل الـ dock */
.lang-switcher--in-dock {
  border: none;
  background: transparent;
  height: 30px;
  overflow: visible;
  box-shadow: none;
}

.lang-switcher__btn {
  border: none;
  background: transparent;
  padding: 0 12px;
  min-width: 2.35rem;
  height: 100%;
  font-size: 0.65rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  cursor: pointer;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  color: rgba(0, 102, 51, 0.72);
  transition: color 0.2s ease, background 0.22s ease, box-shadow 0.22s ease, transform 0.18s ease;
}

.top-navbar-main.navbar-dark .lang-switcher__btn {
  color: rgba(255, 255, 255, 0.72);
}

.lang-switcher__btn:hover:not(.lang-switcher__btn--active) {
  background: rgba(0, 102, 51, 0.07);
  color: #006633;
}

.top-navbar-main.navbar-dark .lang-switcher__btn:hover:not(.lang-switcher__btn--active) {
  background: rgba(255, 255, 255, 0.09);
  color: #fff;
}

.top-navbar-main.navbar-light .lang-switcher__btn--active {
  background: linear-gradient(145deg, #008844 0%, #006633 55%, #00a85e 100%);
  color: #fff !important;
  box-shadow:
    0 4px 14px rgba(0, 102, 51, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.28);
  transform: scale(1.02);
}

.top-navbar-main.navbar-light .lang-switcher__btn--active:hover {
  box-shadow:
    0 6px 18px rgba(0, 102, 51, 0.42),
    inset 0 1px 0 rgba(255, 255, 255, 0.35);
}

.top-navbar-main.navbar-dark .lang-switcher__btn--active {
  background: linear-gradient(145deg, #f4fff8 0%, #ffffff 55%, #dff7ea 100%);
  color: #065530 !important;
  box-shadow:
    0 0 20px rgba(94, 234, 180, 0.45),
    0 4px 14px rgba(0, 0, 0, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.85);
  transform: scale(1.02);
}

.top-navbar-main.navbar-dark .lang-switcher__btn--active:hover {
  background: linear-gradient(145deg, #ffffff 0%, #f7fffb 50%, #e8f8ef 100%);
  color: #054428 !important;
  box-shadow:
    0 0 26px rgba(94, 234, 180, 0.55),
    0 5px 16px rgba(0, 0, 0, 0.28),
    inset 0 1px 0 rgba(255, 255, 255, 0.92);
}

/* ثيم داخل الـ dock */
.theme-switch-compact--in-dock {
  border: none;
  background: transparent;
  padding: 0 6px 0 4px;
  height: 30px;
  gap: 6px;
  box-shadow: none;
}

.theme-switch-compact--in-dock:hover {
  border: none;
}

.theme-switch-compact {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  direction: ltr;
  box-sizing: border-box;
}

.theme-switch-compact:focus {
  outline: none;
}

.top-navbar-main.navbar-light .theme-switch-compact:focus-visible {
  box-shadow: 0 0 0 2px rgba(0, 102, 51, 0.35);
  border-radius: 999px;
}

.top-navbar-main.navbar-dark .theme-switch-compact:focus-visible {
  box-shadow: 0 0 0 2px rgba(94, 234, 180, 0.35);
  border-radius: 999px;
}

.theme-switch-compact__icon {
  font-size: 0.82rem;
  flex-shrink: 0;
  transition: opacity 0.22s ease, transform 0.22s ease, color 0.2s ease;
}

.theme-switch-compact__icon--sun {
  color: #f0ad4e;
}

.theme-switch-compact__icon--moon {
  color: #6c9eff;
}

.theme-switch-compact__track {
  position: relative;
  width: 34px;
  height: 18px;
  border-radius: 999px;
  flex-shrink: 0;
  transition: background 0.25s ease, box-shadow 0.25s ease;
}

.top-navbar-main.navbar-light .theme-switch-compact__track {
  background: linear-gradient(180deg, #d7dde5 0%, #eef1f5 100%);
  box-shadow: inset 0 2px 5px rgba(0, 0, 0, 0.08);
}

.top-navbar-main.navbar-dark .theme-switch-compact__track {
  background: linear-gradient(180deg, #3d4654 0%, #252b34 100%);
  box-shadow:
    inset 0 2px 8px rgba(0, 0, 0, 0.45),
    0 0 12px rgba(94, 234, 180, 0.15);
}

.theme-switch-compact__thumb {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: linear-gradient(145deg, #ffffff 0%, #f0f4f8 100%);
  border: 1px solid rgba(0, 102, 51, 0.35);
  transition: transform 0.28s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.18);
}

.theme-switch-compact__thumb--on {
  transform: translateX(16px);
}

.top-navbar-main.navbar-dark .theme-switch-compact__thumb {
  border-color: rgba(255, 255, 255, 0.35);
  box-shadow:
    0 2px 10px rgba(0, 0, 0, 0.35),
    0 0 12px rgba(255, 255, 255, 0.35);
}

.theme-switch-compact--dark-mode .theme-switch-compact__track {
  box-shadow:
    inset 0 2px 8px rgba(0, 0, 0, 0.5),
    0 0 16px rgba(94, 234, 160, 0.35);
}

.theme-switch-compact--dark-mode .theme-switch-compact__icon--sun {
  opacity: 0.45;
  transform: scale(0.92);
}

.theme-switch-compact--dark-mode .theme-switch-compact__icon--moon {
  opacity: 1;
  transform: scale(1.05);
  color: #b8d4ff;
  filter: drop-shadow(0 0 6px rgba(120, 180, 255, 0.55));
}

.top-navbar-main.navbar-light .theme-switch-compact:not(.theme-switch-compact--dark-mode) .theme-switch-compact__icon--sun {
  opacity: 1;
  filter: drop-shadow(0 0 5px rgba(240, 173, 78, 0.45));
}

.top-navbar-main.navbar-light .theme-switch-compact:not(.theme-switch-compact--dark-mode) .theme-switch-compact__icon--moon {
  opacity: 0.5;
}

/* زر التواصل — نفس الارتفاع تقريبًا + لمسة premium */
.btn-contact-nav {
  white-space: nowrap;
  border-radius: 999px !important;
  padding: 0.42rem 1.15rem !important;
  font-size: 0.8125rem;
  font-weight: 700;
  letter-spacing: 0.03em;
  border: none !important;
  transition: transform 0.22s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.28s ease !important;
}

.btn-contact-nav--wow {
  background: linear-gradient(135deg, #009654 0%, #006633 38%, #004d29 100%) !important;
  box-shadow:
    0 6px 22px rgba(0, 102, 51, 0.42),
    0 2px 8px rgba(0, 80, 45, 0.25),
    inset 0 1px 0 rgba(255, 255, 255, 0.28) !important;
}

.btn-contact-nav--wow:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow:
    0 10px 32px rgba(0, 102, 51, 0.48),
    0 0 24px rgba(0, 204, 120, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.35) !important;
}

.btn-contact-nav--wow:active {
  transform: translateY(0) scale(0.98);
}

.top-navbar-main.navbar-dark .btn-contact-nav--wow {
  background: linear-gradient(135deg, #00b366 0%, #008f52 35%, #006633 100%) !important;
  box-shadow:
    0 6px 26px rgba(0, 0, 0, 0.45),
    0 0 28px rgba(0, 212, 130, 0.38),
    inset 0 1px 0 rgba(255, 255, 255, 0.32) !important;
}

@media (prefers-reduced-motion: reduce) {
  .nav-dock:hover,
  .btn-contact-nav--wow,
  .btn-contact-nav--wow:hover,
  .btn-contact-nav--wow:active,
  .lang-switcher__btn--active,
  .theme-switch-compact__thumb {
    transition: none !important;
    transform: none !important;
  }
}</style>